export default "__VITE_ASSET__Cn$WI46C__"